import { render, staticRenderFns } from "./AsingTaskDependency.vue?vue&type=template&id=65380662&"
import script from "./AsingTaskDependency.ts?vue&type=script&lang=ts&"
export * from "./AsingTaskDependency.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports